// extracted by mini-css-extract-plugin
export default {"loadingSymbol":"LoadingModal_loadingSymbol__LURmF","section":"LoadingModal_section__7eE4H"};